/**
 * The preview-only CRM trigger page (`/admin/crm-triggers`, ENG-2172).
 * Served by `apps/api/src/crm-admin`; every run returns the job's own result
 * as JSON, shown on the page as it is.
 */
/** The scheduled CRM jobs the page can fire by hand, keyed as the API takes them. */
export const crmTriggerJobLabels = {
    'clinic-health': 'Nightly clinic health',
    'onboarding-sync': 'Onboarding sync and alerts',
    'onboarding-digest': 'Monday onboarding digest',
    'demo-reminders': 'Demo reminders',
    'contract-nudge': 'Unsigned-contract nudge',
};
export const crmTriggerJobValues = Object.keys(crmTriggerJobLabels);
/** The onboarding sync's platform signals the page can switch on or off for a clinic. */
export const onboardingSignalLabels = {
    meta_connected: 'Meta connected',
    stripe_connected: 'Stripe payments set up',
    data_received: 'Data received',
};
export const onboardingSignalValues = Object.keys(onboardingSignalLabels);
//# sourceMappingURL=crm-triggers.js.map